<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button class="md-simple md-just-icon md-primary" @click="openModal">
				<i class="fa" :class="hasMessage ? 'fa-envelope' : 'fa-envelope-o'" style="font-size: 28px !important;" />
			</md-button>
		</div>
	</div>
</template>
<script>

export default {
	methods: {
		openModal() {
			this.params.showMessageModalFunc(this.params.data);
		},
	},
	computed: {
		hasMessage() {
			return this.params.data.countMessage > 0;
		}
	}

}
</script>